import { render } from "./EmailAddressModal.vue?vue&type=template&id=21ad9949&scoped=true&ts=true"
import script from "./EmailAddressModal.vue?vue&type=script&lang=ts"
export * from "./EmailAddressModal.vue?vue&type=script&lang=ts"

import "./EmailAddressModal.vue?vue&type=style&index=0&id=21ad9949&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ad9949"]])

export default __exports__